import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { STATUS } from 'utils/constants'
import { GET } from 'rest/request'
import * as urls from 'rest/urls'

export const ACCOUNT_TYPE = {
  basic: 'basic',
  cards: 'cards',
  share: 'share',
  company: 'company',
  invoices: 'invoices',
  payments: 'payments',
  settings: 'settings',
  schedule: 'schedule',
  invoiceRecipients: 'invoiceRecipients',
}

const getUrl = type => {
  switch (type) {
    case ACCOUNT_TYPE.payments: return urls.payments
    case ACCOUNT_TYPE.company: return urls.companies
    case ACCOUNT_TYPE.cards: return urls.paymentmethods
    case ACCOUNT_TYPE.schedule: return urls.paymentsSchedule
    case ACCOUNT_TYPE.invoiceRecipients: return urls.invoiceRecipients
    default: return urls.userInfo
  }
}

export const fetchUserData = createAsyncThunk(
  'user/fetchUserData',
  /**
   * @param {string} [type=ACCOUNT_TYPE.basic]
   */
  async (type = ACCOUNT_TYPE.basic) => {
    const response = await GET(getUrl(type))
    return {
      data: type === ACCOUNT_TYPE.schedule ? response : response?.data,
      type
    }
  })

export const getPaymentDetails = createAsyncThunk('user/fetchPaymentsDetails',
  /**
   * @param {string} id
   */
  async (id) => {
    const response = await GET(`${urls.payments}/${id}`)
    return response
  })

const accountSlice = createSlice({
  name: 'account',
  initialState: {},
  reducers: {
    updateValue: (state, action) => {
      const { type, name, value } = action.payload
      if (type && name) {
        state[type] = { ...state[type], [name]: value }
      }
    },
    resetAccount: () => {
      return {}
    }
  },
  extraReducers(builder) {
    builder
      .addCase(fetchUserData.fulfilled, (state, action) => {
        const { data, type } = action.payload
        state[type] = { data, status: STATUS.succeed }
      })
      .addCase(fetchUserData.pending, (state, action) => {
        const { arg: type } = action.meta
        if (state[type]) {
          state[type].status = STATUS.pending
        } else {
          state[type] = { status: STATUS.pending }
        }
      })
      .addCase(fetchUserData.rejected, (state, action) => {
        const { arg: type } = action.meta
        state[type] = { status: STATUS.failed }
      })
      .addCase(getPaymentDetails.fulfilled, (state, action) => {
        const data = action.payload.data
        if (state[ACCOUNT_TYPE.payments]?.data) {
          state[ACCOUNT_TYPE.payments].data = state[ACCOUNT_TYPE.payments].data.map(payment => payment.id === data.id ? data : payment)

        } else {
          state[ACCOUNT_TYPE.payments] = {
            data: [data]
          }
        }
      })
  }
})

export const { updateValue, resetAccount } = accountSlice.actions

export const selectUserData = (state, type = ACCOUNT_TYPE.basic) => state.account[type] || {}

export default accountSlice.reducer